import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BASE_API_URL } from '@curbnturf/entities';
import { IArticle } from '@curbnturf/objects';
import { Observable, catchError, of, shareReplay } from 'rxjs';

/**
 * Thin, session-cached read adapter for the real articles backend
 * (`GET {apiUrl}/api/v1/article`, public, no auth). Deliberately bypasses
 * the legacy `@curbnturf/article` NgRx/`CachedHttpClient` stack — that
 * stack pulls in `NetworkModule`'s offline-queue machinery and dispatches
 * a global alert on fetch failure, neither of which fits a public,
 * read-only, anonymous content feed where a failed fetch should resolve
 * to an empty list, not a user-facing error toast.
 */
@Injectable({ providedIn: 'root' })
export class ArticleCatalogService {
  private http = inject(HttpClient);
  private readonly url = `${BASE_API_URL}article`;

  private readonly articles$: Observable<IArticle[]> = this.http.get<IArticle[]>(this.url).pipe(
    catchError(() => of([])),
    shareReplay({ bufferSize: 1, refCount: false }),
  );

  getArticles$(): Observable<IArticle[]> {
    return this.articles$;
  }
}
